import script from "./btn.vue?vue&type=script&lang=ts&setup=true"
export * from "./btn.vue?vue&type=script&lang=ts&setup=true"

import "./btn.vue?vue&type=style&index=0&id=61f3f85e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61f3f85e"]])

export default __exports__